export enum EnvironmentName {
  local,
  test,
  prod
}
